// ═══════════════════════════════════════════════════════════════
// PIXALLOY — StatusBar Render Function
// ═══════════════════════════════════════════════════════════════
// Pure display — no interaction, no state, no refs.
// Called inline from PixAlloy.jsx as renderStatusBar({...}).
// ═══════════════════════════════════════════════════════════════

import { V } from "../theme.js";

export function renderStatusBar({ toolLabel, cw, ch, curPos, zmDisplay, rotDisplay, wasmCaps, layers, E }) {
  return (
    <div style={{height:22,background:V.panelBg,borderTop:`1px solid ${V.panelBorder}`,display:"flex",alignItems:"center",padding:"0 12px",gap:16,fontSize:10,color:V.ghost,flexShrink:0}}>
      <span style={{color:V.accentL}}>{toolLabel}</span>
      <div style={{width:1,height:12,background:V.panelBorder}}/>
      <span>{cw} × {ch} px</span>
      <div style={{width:1,height:12,background:V.panelBorder}}/>
      <span>Cursor: {Math.round(curPos.x)}, {Math.round(curPos.y)}</span>
      <div style={{width:1,height:12,background:V.panelBorder}}/>
      <span>Zoom: {zmDisplay}%</span>
      {rotDisplay!==0&&<><div style={{width:1,height:12,background:V.panelBorder}}/><span style={{color:"#fbbf24"}}>Rot: {rotDisplay}°</span></>}
      <div style={{flex:1}}/>
      <span style={{color:"#4ade80"}}>● ENGINE READY</span>
      {wasmCaps&&<><div style={{width:1,height:12,background:V.panelBorder}}/><span style={{color:wasmCaps.sharedMemory?"#4ade80":"#fbbf24",fontSize:9}}>{wasmCaps.sharedMemory?"SAB":"JS"}{wasmCaps.worker?" · Worker":""}{ wasmCaps.wasm?" · Wasm":""}</span></>}
      <div style={{width:1,height:12,background:V.panelBorder}}/>
      <span>ABI v3 · Layers: {layers.length}{layers.filter(l=>l.type==="adjustment").length>0?" ("+layers.filter(l=>l.type==="adjustment").length+" adj)":""} · Undo: {E?.s.undo.length??0}</span>
      {E?.s.sel&&<><div style={{width:1,height:12,background:V.panelBorder}}/><span style={{color:V.accentL,fontSize:9}}>SEL · Ctrl+D to clear</span></>}
    </div>
  );
}
